import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '',
    isShow: true,
    goodsInfo: localStorage.getItem('goodsInfo') ? JSON.parse(localStorage.getItem('goodsInfo')) : ''
  },
  mutations: {
    setUserInfo (state, info) {
      console.log(info)
      if (info) {
        localStorage.setItem('userInfo', JSON.stringify(info))
        state.userInfo = info
      } else {
        localStorage.removeItem('userInfo')
        state.userInfo = ''
      }
    },
    changeIsShow (state, bol) {
      state.isShow = bol
    },
    setGoodsInfo (state, info) {
      console.log(info)
      localStorage.setItem('goodsInfo', JSON.stringify(info))
      state.goodsInfo = info
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    shopName: (state) => {
      if (state.userInfo) {
        return state.userInfo.shop_name
      }
    },
    token: (state) => {
      if (state.userInfo) {
        return state.userInfo.shop_token
      }
    }
  }
})
